// extracted by mini-css-extract-plugin
export var attribution = "AdditionalInfo-module--attribution--47ac8";
export var attributionLink = "AdditionalInfo-module--attributionLink--cbbd1";
export var figureWrapper = "AdditionalInfo-module--figureWrapper--ae5c1";
export var headingStyle = "AdditionalInfo-module--headingStyle--822f0";
export var infoContainer = "AdditionalInfo-module--infoContainer--acc52";